import React, { useState } from 'react';

export function StarRating({ rating, onRatingChange }) {
    const [hoverRating, setHoverRating] = useState(0);

    const handleClick = (star) => {
        onRatingChange(rating === star ? 0 : star);
    };

    const displayRating = hoverRating || rating;

    return (
        <div className="star-rating">
            {[1, 2, 3, 4, 5].map((star) => (
                <button
                    key={star}
                    type="button"
                    className={`star-rating__star ${star <= displayRating ? 'star-rating__star--filled' : ''}`}
                    onClick={() => handleClick(star)}
                    onMouseEnter={() => setHoverRating(star)}
                    onMouseLeave={() => setHoverRating(0)}
                    title={`${star} estrella${star > 1 ? 's' : ''}`}
                >
                    <i className={`${star <= displayRating ? 'fas' : 'far'} fa-star`}></i>
                </button>
            ))}
        </div>
    );
}
